import { render, staticRenderFns } from "./InvestmentOrderDetailModal.vue?vue&type=template&id=453f37f0&scoped=true"
import script from "./InvestmentOrderDetailModal.vue?vue&type=script&lang=js"
export * from "./InvestmentOrderDetailModal.vue?vue&type=script&lang=js"
import style0 from "./InvestmentOrderDetailModal.vue?vue&type=style&index=0&id=453f37f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f37f0",
  null
  
)

export default component.exports